import React from 'react';
import { constants } from '../../utils/constants';
import TranslatedComponent from '../../utils/TranslatedComponent';
import { callTealiumLink, determineLegalCountry, isEmeaCountry } from '../../utils/helpers';

class DefaultFooter extends React.Component {
  constructor(props) {
    super(props);

    this.analyticsClick = this.analyticsClick.bind(this);
  }
  analyticsClick(linkName) {
    callTealiumLink({
      event_name: 'linkClick',
      link_category: 'exit',
      link_name: linkName,
    });
  }

  render() {
    const legalCountry = determineLegalCountry();
    const showIfNotEMEA = !isEmeaCountry();

    return (
      <p>
        <span className='footerCopyright'>
          {this.translate('footerCopyright')}
        </span>
        <span className='footerPipe pipe1'> |</span>
        {showIfNotEMEA && (
          <React.Fragment>
            <a
              id='interestBasedAds-FooterLink'
              href={constants.interestBasedAdsHref}
              onClick={() => {
                this.analyticsClick('Postal');
              }}
              target='_blank'
            >
              {this.translate('footerAds')}
            </a>
            <span className='footerPipe pipe2'> |</span>
          </React.Fragment>
        )}
        <a
          id='childrensPrivacyPolicy-FooterLink'
          href={constants.childrensPrivacyPolicyHref}
          onClick={() => {
            this.analyticsClick("Children's Privacy");
          }}
          target='_blank'
          >
          {this.translate('footerChildrensPrivacy')}
        </a>
        <span className='footerPipe pipe3'> |</span>
        <span className='block'>
          <a
            id='californiaPrivacyRights-FooterLink'
            href={constants.usStatePrivacyRightsHref}
            onClick={() => {
              this.analyticsClick('CA Privacy');
            }}
            target='_blank'
            >
            {this.translate('footerUsStatePrivacy')}
          </a>
          <span className='footerPipe pipe4'> |</span>
          <a
            id='doNotSellMyInfo-FooterLink'
            href={constants.doNotSellOrShareMyInfoHref}
            onClick={() => {
              this.analyticsClick('Do Not Sell My Info');
            }}
            target='_blank'
            className={legalCountry === 'US' ? 'ot-cmp-link' : ''}
            >
            {this.translate('ccpaUSLegalLink')}
          </a>
          <span className='footerPipe pipe4'> |</span>
          <a
            id='termsOfUse-FooterLink'
            href={constants.termsOfUseHref}
            onClick={() => {
              this.analyticsClick('Terms of Use');
            }}
            target='_blank'
            >
            {this.translate('footerTerms')}
          </a>
          <span className='footerPipe pipe5'> |</span>
          <a
            id='privacyPolicy-FooterLink'
            href={constants.privacyPolicyHref}
            className='last'
            onClick={() => {
              this.analyticsClick('Privacy');
            }}
            target='_blank'
            >
            {this.translate('privacyTitle')}
          </a>
        </span>
      </p>
    );
  }
}

TranslatedComponent(DefaultFooter);
module.exports = DefaultFooter;



// WEBPACK FOOTER //
// ./client/src/components/footer/DefaultFooter.jsx